import { Navigate, useParams, useSearchParams } from 'react-router-dom';

function withQueryString(basePath: string, searchParams: URLSearchParams): string {
  const qs = searchParams.toString();
  return qs ? `${basePath}?${qs}` : basePath;
}

export function LegacyOrganizationSettingsPathRedirect() {
  const [searchParams] = useSearchParams();
  return (
    <Navigate to={withQueryString('/admin/organization/settings', searchParams)} replace />
  );
}

export function LegacyAcademySettingsPathRedirect() {
  const [searchParams] = useSearchParams();
  return <Navigate to={withQueryString('/admin/academy/settings', searchParams)} replace />;
}

export function LegacyCourtsLocationRedirect() {
  const { locationId } = useParams();
  return <Navigate to={`/admin/courts/location/${locationId}`} replace />;
}

export function LegacyStudentDetailRedirect() {
  const { studentId } = useParams();
  return <Navigate to={`/admin/students/${studentId}`} replace />;
}

export function LegacyPlayEventDetailRedirect() {
  const { eventId } = useParams();
  return <Navigate to={`/admin/play-events/${eventId}`} replace />;
}

export function LegacyPlayEventKioskRedirect() {
  const { eventId } = useParams();
  return <Navigate to={`/admin/play-events/${eventId}/kiosk`} replace />;
}

export function LegacyPlayEventBoardRedirect() {
  const { eventId } = useParams();
  return <Navigate to={`/admin/play-events/${eventId}/board`} replace />;
}
